export default "__VITE_ASSET__eABCl0iA__"